import { AsyncPipe } from "@angular/common";
import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { CoreDevBanner, CoreIconButton, CoreSidebar, CoreSvsLogo, SvsBreakpointService } from "@svs/angular";
import { environment } from "../../environments/environment";
import { AuthTokenLoaderComponent } from "./auth-token-loader/auth-token-loader.component";
import { HeaderBarComponent } from "./header-bar/header-bar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";

@Component({
  selector: "app-layout",
  imports: [
    RouterOutlet,
    CoreSidebar,
    SidebarComponent,
    CoreSvsLogo,
    HeaderBarComponent,
    CoreIconButton,
    AsyncPipe,
    CoreDevBanner,
    AuthTokenLoaderComponent,
  ],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.scss",
})
export class LayoutComponent implements OnInit {
  @ViewChild("sidebar") sidebar?: CoreSidebar;

  breakpointService = inject(SvsBreakpointService);

  isMobile$ = this.breakpointService.isMobile$;

  production = environment.production;

  _open: boolean = true;

  ngOnInit(): void {
    this.isMobile$.subscribe(mobile => {
      this.open = !mobile;
    });
  }

  set open(open: boolean) {
    this._open = open;
    if(this.sidebar) {
      this.sidebar.open = open;
    }
  }
}
